import { createFileRoute, redirect } from '@tanstack/react-router'
import router from '#app/router'
import { getCurrentUserRoleInfo } from '#shared/lib/auth'
import { combinePaths } from '#shared/lib/strings'

export const Route = createFileRoute(
  '/staff/_pre-registration-required/post-register',
)({
  loader: () => {
    const roleInfo = getCurrentUserRoleInfo()

    const currentPathname = router.state.location.pathname

    if (
      roleInfo.isGiven &&
      currentPathname === combinePaths(router.basepath, '/staff/post-register')
    ) {
      throw redirect({ to: '/staff/profile' })
    }
  },
})
